import iconSmaki from "assets/icons/smaki.png";
import iconGo from "assets/icons/go.png";
import iconMoonfish from "assets/icons/moonfish.png";
import iconOhMyPizza from "assets/icons/ohmypizza.png";
import iconDonatello from "assets/icons/donatello.png";

export const renderIcon = (restaurant) => {
  switch (restaurant) {
    case "smaki": return iconSmaki;
    case "go": return iconGo;
    case "moonfish": return iconMoonfish;
    case "ohmypizza": return iconOhMyPizza;
    case "donatello": return iconDonatello;
    default: return null;
  }
};
